(function () {
  'use strict';
  angular.module('vcpatdocs')
    .component('imagingconfig', {
      restrict: 'E',
      bindings: {
      },
      templateUrl: 'vcpatdocs/imagingconfig-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', 'Config', 'Rlog', '$timeout',
        function ($log, Config, Rlog, $timeout) {
          let vm = this;


          vm.options = {updateOn: 'default blur', debounce: {default: 20000, blur: 0}};
          vm.saveConfig = saveConfig;
          vm.loadValues = loadValues;
          vm.addGroup = addGroup;
          vm.removeGroup = removeGroup;
          vm.saveConfig = saveConfig;

          vm.$onInit = function () {
            //  get imagings and groups from config
            Config.$find('imagingconfiguration').$then(imagingconfig => {
              if (!imagingconfig.hasOwnProperty('_id')) {
                imagingconfig._id = 'imagingconfiguration';
              }
             if (!imagingconfig.hasOwnProperty('groups')) {
                imagingconfig.groups = [];
              }
              if (!imagingconfig.hasOwnProperty('values')) {
                imagingconfig.values = [];
              }
              vm.imagingconfig = imagingconfig;
            }, error => {
              $log.error('Loading of imagingconfiguration failed');
              Rlog.error('patdocs', 'imagingconfig', 'imagingconfiguration.$find() failed', {id: 'imagingconfiguration'});
            })
          }; // $onInit()


          function addGroup() {
            // vm.imagingconfig.groups.push({name: vm.newgroup, values: []});
            vm.imagingconfig.groups.splice(0, 0, {name: vm.newgroup, values: []});
            vm.newgroup = '';
            vm.saveConfig();
          }

          function removeGroup(index) {
            vm.imagingconfig.groups.splice(index, 1);
            vm.saveConfig();
          }

          function saveConfig() {
            let changedgroups = [];

            vm.imagingconfig.values = uniq(vm.imagingconfig.values);
            for (let i = 0; i < vm.imagingconfig.groups.length; i++){
              changedgroups.push({
                name: vm.imagingconfig.groups[i].name,
                values: uniq(vm.imagingconfig.groups[i].values)
              });
            }
            vm.imagingconfig.groups = changedgroups;
            vm.imagingconfig.$save();
          }

          function uniq(a) {
            return a.sort().filter(function (item, pos, ary) {
              return !pos || item !== ary[pos - 1];
            });
          }

          // load and filter autocomplete values
          function loadValues($query) {
            let promise = new Promise(function (resolve, reject) {
              resolve(vm.imagingconfig.values);
            });
            return promise.then(function (values) {
              $log.debug('promise values: ', values);
              let filteredValues = values.filter(function (value) {
                return value.name.toLowerCase().indexOf($query.toLowerCase()) !== -1;
              });
              console.log('filtered values: ', filteredValues);
              return filteredValues;
            });
          }


        }
      ] // controller
    }); // component

// klammerfriedhof
}());